import { Breakpoints, styled } from '@vw-marketing/us-components';

interface StyledModelCardWrapperProps {
  emptyOffersModal?: boolean;
}

export const NewStyledOfferSectionWrapper: any = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;

  @media (max-width: ${Breakpoints.b560}px) {
    flex-direction: column;
    padding-bottom: 0;
    gap: 10px;
    width: 100vw;
  }

  @media (min-width: 2000px) {
    gap: 5px;
  }
`;

export const StyledModelCardWrapper = styled.div<StyledModelCardWrapperProps>`
  flex: ${props => (props.emptyOffersModal ? 1 : 0.5)};
  min-width: 320px;
  width: 100%;

  @media (max-width: ${Breakpoints.b560}px) {
    min-width: 100vw;
  }

  @media (max-width: ${Breakpoints.b1600}px) and (min-width: ${Breakpoints.b960}px) {
    min-width: 300px;
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    min-width: 400px;
  }
`;

export const StyledOfferCardWrapper: any = styled.div`
  ${({isModalMode = false}) => {
    return `
      flex: 2;
      overflow: hidden;
      margin-right: var(--offer-card-margin-right);

      @media (max-width: ${Breakpoints.b560}px) {
        flex-direction: column;
        margin-top: -30px;
        margin: 0 20px;
        width: auto;
        ${!isModalMode && '--offer-card-margin-right: 0;'} 
      }

      ${!isModalMode && `            
          --offer-card-margin-right: -8.3vw;

          @media (max-width: ${Breakpoints.b960}px) {
            --offer-card-margin-right: 0;
          }
        `
      }
    `
  }}
`;